import { render, staticRenderFns } from "./BackTestHistory.vue?vue&type=template&id=510d8e90&scoped=true&"
import script from "./BackTestHistory.vue?vue&type=script&lang=js&"
export * from "./BackTestHistory.vue?vue&type=script&lang=js&"
import style0 from "./BackTestHistory.vue?vue&type=style&index=0&id=510d8e90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510d8e90",
  null
  
)

export default component.exports